module.exports = __webpack_public_path__ + "img/darkmode_logo.d4c38dba.png";